import React, { FC } from "react";

import InsightsIcon from "@mui/icons-material/Insights";
import { Button, keyframes } from "@mui/material";

interface AiButtonProps {
	handleOpen: (group: any) => void;
	isDisabled?: boolean
	isMobile: boolean;
	label: string;
}

export const AiButton: FC<AiButtonProps> = ({
	handleOpen,
	isDisabled,
	isMobile,
	label,
}) => {
	return (
		<Button
			variant="contained"
			color="info"
			onClick={handleOpen}
			sx={{
				width: isMobile ? "100%" : "auto",
				animation: isDisabled ? "none" : `${pulseAnimation} 4s infinite ease-in-out`,
				height: "40px",
			}}
			startIcon={<InsightsIcon />}
			disabled={isDisabled ?? false}
		>
			{label}
		</Button>
	);
};

const pulseAnimation = keyframes`
  0% {
    box-shadow: 0 0 2px 0px rgba(255, 235, 0, 0.7);
  }
  50% {
    box-shadow: 0 0 15px 5px rgba(255, 235, 0, 1.0);
			
  }
  100% {
    box-shadow: 0 0 2px 0px rgba(255, 235, 0, 0.7);
  }
`;
